import { render, staticRenderFns } from "./AttendeeWizard.vue?vue&type=template&id=612437b8&scoped=true&"
import script from "./AttendeeWizard.vue?vue&type=script&lang=js&"
export * from "./AttendeeWizard.vue?vue&type=script&lang=js&"
import style0 from "./AttendeeWizard.vue?vue&type=style&index=0&id=612437b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612437b8",
  null
  
)

export default component.exports